import type { EventRecord } from "@/shared/domain/events";
import type { EventConfig } from "@/shared/state/visualization";

/**
 * The events the user has not hidden. An event with no per-event config defaults
 * to visible, matching how the timeline and plot annotations treat a missing
 * config.
 */
export function selectVisibleEvents(
  events: EventRecord[],
  eventConfigs: Record<string, EventConfig> | undefined,
): EventRecord[] {
  return events.filter(
    (event) => eventConfigs?.[event.event_id]?.isVisible ?? true,
  );
}

/**
 * The subset of `events` whose time window contains `timeNs`. Both bounds are
 * inclusive, and `timeNs` and the event bounds are all absolute nanosecond
 * epochs (bigint), so they compare directly.
 */
export function selectActiveEvents(
  events: EventRecord[],
  timeNs: bigint,
): EventRecord[] {
  return events.filter(
    (event) => event.start_time <= timeNs && timeNs <= event.end_time,
  );
}
